import React from "react";
import { LARAVEL_APP_HOME } from "../../constants";
import { Box } from "@mui/material";
import { AtticusCircularProgress } from "views/shared/AtticusCircularProgress";

export const Home = (): JSX.Element => {
  window.location.href = LARAVEL_APP_HOME

  return <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
    }}
  >
    <AtticusCircularProgress />
  </Box>
};
